export default __webpack_public_path__ + "static/media/guide12.77689460.png";